import type { Entity } from 'playcanvas';
import type { ViewerXrApi, VrQualityPreset } from '@mindcloudxai/shared';
import type { Global } from '../../../submodules/supersplat-viewer/src/types';
import type { App } from '../../../submodules/supersplat-viewer/src/app';
import { enterVrSession } from '../xr-lifecycle';

export function createXrApi(options: {
  getApp: () => App;
  getCamera: () => Entity;
  getGlobal: () => Global;
  isDisposed: () => boolean;
  assertInitialized: () => void;
}): ViewerXrApi {
  return {
    enterVr: (preset?: VrQualityPreset) => {
      options.assertInitialized();
      return enterVrSession(
        options.getApp(),
        options.getCamera(),
        options.getGlobal(),
        options.isDisposed(),
        preset,
      );
    },
  };
}
